<template>
  <div class="checkbox" :class="{ 'checkbox--inverse': inverse, 'checkbox--has-error': error }">
    <div class="checkbox-body">
      <input
        :id="labelName"
        type="checkbox"
        v-bind:checked="checked"
        v-on:change="$emit('change', $event.target.checked)"
      >
      <label :for="labelName"><slot /></label>
    </div>
    <div class="error">{{ error }}</div>
  </div>
</template>

<style scoped lang="scss">
  .checkbox {
    margin-bottom: 15px;

    .checkbox-body {
      display: flex;
      width: 100%;
    }

    label {
      font-size: var(--small);
      color: rgb(var(--gray-10));
    }

    input {
      flex: 0 0 20px;
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }

    .error {
      display: none;
    }

    &--inverse {
      label {
        color: rgb(var(--white));
      }
    }

    &--has-error {
      .checkbox-body {
        padding: 0.5em;
        border: 2px solid rgb(var(--red-0));
      }

      .error {
        display: block;
        float: right;
        text-align: right;
        margin-right: 5px;
        padding: 0.25em 0.5em;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        background-color: rgb(var(--red-0));

        font-size: var(--small);
        font-weight: var(--weight-bold);
        color: rgb(var(--white));
      }
    }
  }
</style>

<script>
  export default {
    name: 'InputCheckbox',

    inheritAttrs: false,

    model: {
      prop: 'checked',
      event: 'change'
    },

    props: {
      checked: {
        type: Boolean,
        default: false
      },

      inverse: {
        type: Boolean,
        default: false
      },

      error: {
        type: String,
        default: ''
      },

      labelName: {
        type: String,
        default: 'checkbox'
      }
    }
  };
</script>